<template>
  <ClientDomainClientsModule />
</template>

<script>
import ClientDomainClientsModule from '@/modules/masterData/clientDomainClients/components/main.vue';

export default {
  name: 'MasterDataClientsDomainClients',
  components: {
    ClientDomainClientsModule,
  },
};
</script>
